import React from 'react'

import cn from '../../libs/class-names'

export type Spacings =
  | '60'
  | '70'
  | '80'
  | '90'
  | '100'
  | '200'
  | '300'
  | '400'
  | '500'
  | '600'
  | '700'
  | '800'
  | '900'
  | '1000'
  | '1100'
  | '1200'
  | '1300'
  | '1400'

export interface Props {
  classNames?: string[]
  children?: React.ReactNode
  /** Accepts all CCDS spacings values */
  space?: Spacings
  /** Overrides space for tablet screen sizes */
  spaceM?: Spacings
  /** Overrides space for desktop screen sizes */
  spaceL?: Spacings
}

/**
 * The props **space**, **spaceM** and **spaceL** accept all CCDS spacings values ('60', '70', ..., '1400').
 *
 * Use **spaceM** and **spaceL** to add a responsive behaviour (tablet and desktop).
 */
const Stack = ({classNames, children, space = '100', spaceM, spaceL}: Props) => (
  <div
    className={cn(
      'Stack',
      {[`space-${space}`]: !!space, [`spaceM-${spaceM}`]: !!spaceM, [`spaceL-${spaceL}`]: !!spaceL},
      classNames
    )}
  >
    {children}
  </div>
)

export default Stack
